export const getEnv = (domain: string | any) => {
    let domainName;
    const hostName = window.location.hostname.split('.');
    if (hostName.length > 0) {
        domainName = hostName.slice(1).join('.');
    }
    const givenDomainNameSplitted = domain.split('.');
    return `${givenDomainNameSplitted.slice(0, 1)}.${domainName}`;
};
